<px-catalog-header/>
<div class="flex-col gap-7 px-4 md:px-8 mt-8">
  @for (carousel of carouselSelectors.catalogCarousels | select:[]; track carousel.id) {
    <px-catalog-carousel-card [carouselTitle]="carousel.title" [carouselItems]="carousel.catalogRecords"
                              noItemsMessage="There are no items in this collection." titleClasses="pb-0"/>
  }
</div>
